import React from "react";

import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meanings(props) {
  if (props.meaning) {
    return (
      <div className="Meaning">
        <h3>{props.meaning.partOfSpeech}</h3>
        <p>{props.meaning.definition}</p>
        <em>{props.meaning.example}</em>
        <Synonyms synonym={props.meaning.synonyms} />
      </div>
    );
  } else {
    return null;
  }
}
